import React from "react";

import { Card, CardTitle, CardDescription } from "./styles";

interface HeaderCardProps {
  title: string;
  description: string;
}

export const HeaderCard = ({ title, description }: HeaderCardProps) => {
  return (
    <Card className="header-card">
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </Card>
  );
};
